/**
 * Created by lihanying on 2017/7/17.
 */
import React from 'react'
import {Button, message, Table} from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import 'whatwg-fetch'
import ModalDetail from './modalDetail'
import ModalInterval from './modalInterval'
import {API_DOMAIN} from '../../../config'
import {fetchData} from '../../../util/index'
import LowCsp from './lowCsp'
import PackageManager from './packageManager'
import BatchEditPackage from './batchEditPackage'
import BooksettingsModal from './bookSettingsModal/bookSettingsModal'
import TableInfoModal from './tableInfoModal/tableInfoModal'
import {fetchClubTableType, fetchTableDetail, postTableDetail,} from '../../../api/clubProfession'
import {postTablesLowPrice, postTablesTimePrice} from '../../../api/clubTable'
import './style.css'

export default class extends React.Component {
  state = {
    isLoading: false,
    visible: false,
    modal: false,
    modalAddTable: false,
    modalLowCsp: false,
    selectedRowKeys: [],
    wallet_id: 0,
    createPercent: -1,
    downloadPercent: -1,
    isShowBatchEditModal: false,
    isShowPackageManager: false,
    tableDetailInfo: {},
    tableTypes: [],
    tables: [],
    showBookSettingsModal: false,
    isShowReserve: false,
  }
  componentDidMount() {
    // this.props.fetchClubTableType()
    this.props.fetchTotalType()
    this.getTableType()

      this.setState({
        isShowReserve: true,
      })

  }

  onShow = (record) => {
    const data = {
      club_id: sessionStorage.getItem('club_id'),
      table_id: record.table_id,
    }
    // this.props.fetchClubTableInfo(data)
    this.getTableDetailInfo(record.table_id)
    this.props.fetchClassifyWallet(record.type)
    this.setState({ record: record })
  }

  // 获取球台详情
  getTableDetailInfo = (tableId) => {
    this.setState({ isLoading: true })
    fetchTableDetail({
      tableId: tableId,
    }).then((res) => {
      this.setState({ isLoading: false })
      if (res.status != 1) {
        message.error(res.detail)
        return
      }
      res.data.table.hourPrice = res.data.table.hourPrice / 100
      res.data.minConsumption = res.data.minConsumption / 60
      this.setState(
        {
          tableDetailInfo: res.data,
        },
        () => {
          this.setState({
            visible: true,
          })
        }
      )
    })
  }

  // 获取业务分组列表
  getTableType = () => {
    fetchClubTableType().then((res) => {
      if (res.status != 1) {
        message.error(res.detail)
        return
      }
      this.setState({
        tableTypes: res.data,
      })
    })
  }

  handleOk = (tabIndex) => {
    //修改桌台
    const { record, wallet_id, tableDetailInfo } = this.state
    if (
      sessionStorage.getItem('name') ||
      sessionStorage.getItem('type_id') ||
      sessionStorage.getItem('clz') ||
      sessionStorage.getItem('order_num') ||
      sessionStorage.getItem('table_number') ||
      sessionStorage.getItem('hour_price') ||
      sessionStorage.getItem('checkout') ||
      sessionStorage.getItem('timeMode') ||
      sessionStorage.getItem('low_minute') != null ||
      sessionStorage.getItem('packageOption') != null ||
      sessionStorage.getItem('packageOperation') != null ||
      sessionStorage.getItem('packageNeedFlashingReminder') != null ||
      sessionStorage.getItem('packageNeedWechatReminder') != null ||
      sessionStorage.getItem('couponOption') != null ||
      sessionStorage.getItem('couponOperation') != null ||
      sessionStorage.getItem('couponNeedFlashingReminder') != null ||
      sessionStorage.getItem('couponNeedWechatReminder') != null ||
      sessionStorage.getItem('grouponOperation') != null ||
      sessionStorage.getItem('grouponNeedFlashingReminder') != null ||
      sessionStorage.getItem('grouponNeedWechatReminder') != null
    ) {
      // const data = {
      //   club_id: sessionStorage.getItem('club_id'),
      //   table_id: record.table_id,
      //   name: sessionStorage.getItem('name') || record.name,
      //   type_id: sessionStorage.getItem('type_id') || record.type,
      //   order_num: sessionStorage.getItem('order_num') || record.order_num,
      //   table_number:
      //     sessionStorage.getItem('table_number') || record.table_number,
      //   hour_price: sessionStorage.getItem('hour_price') || record.hour_price,
      //   low_minute: sessionStorage.getItem('low_minute') || record.consumption,
      //   checkout:
      //     sessionStorage.getItem('checkout') ||
      //     this.props.tableInfo.commodity_checkout_instantly,
      // }
      // this.props.fetchUpdateTable(data)

      let settings = []
      if (tableDetailInfo.settings.length != 0) {
        const packageItem = tableDetailInfo.settings.find(
          (item) => item.startType == 4
        )
        const pItem = {
          id: packageItem ? packageItem.id : -1,
          startType: 4,
          option: sessionStorage.getItem('packageOption') || packageItem.option,
          operation:
            sessionStorage.getItem('packageOperation') || packageItem.operation,
          needFlashingReminder:
            sessionStorage.getItem('packageNeedFlashingReminder') == null
              ? packageItem.needFlashingReminder
              : sessionStorage.getItem('packageNeedFlashingReminder') == 1
              ? true
              : false,
          needWechatReminder:
            sessionStorage.getItem('packageNeedWechatReminder') == null
              ? packageItem.needWechatReminder
              : sessionStorage.getItem('packageNeedWechatReminder') == 1
              ? true
              : false,
        }

        const couponItem = tableDetailInfo.settings.find(
          (item) => item.startType == 2
        )
        const cItem = {
          id: couponItem ? couponItem.id : -1,
          startType: 2,
          option: sessionStorage.getItem('couponOption') || couponItem.option,
          operation:
            sessionStorage.getItem('couponOperation') || couponItem.operation,
          needFlashingReminder:
            sessionStorage.getItem('couponNeedFlashingReminder') == null
              ? couponItem.needFlashingReminder
              : sessionStorage.getItem('couponNeedFlashingReminder') == 1
              ? true
              : false,
          needWechatReminder:
            sessionStorage.getItem('couponNeedWechatReminder') == null
              ? couponItem.needWechatReminder
              : sessionStorage.getItem('couponNeedWechatReminder') == 1
              ? true
              : false,
        }

        const grouponItem = tableDetailInfo.settings.find(
          (item) => item.startType == 3
        )
        const gItem = {
          id: grouponItem ? grouponItem.id : -1,
          startType: 3,
          option: 2,
          operation:
            sessionStorage.getItem('grouponOperation') || grouponItem.operation,
          needFlashingReminder:
            sessionStorage.getItem('grouponNeedFlashingReminder') == null
              ? grouponItem.needFlashingReminder
              : sessionStorage.getItem('grouponNeedFlashingReminder') == 1
              ? true
              : false,
          needWechatReminder:
            sessionStorage.getItem('grouponNeedWechatReminder') == null
              ? grouponItem.needWechatReminder
              : sessionStorage.getItem('grouponNeedWechatReminder') == 1
              ? true
              : false,
        }

        settings = [pItem, cItem, gItem]
      }

      const params = {
        table: {
          id: record.table_id,
          name: sessionStorage.getItem('name') || record.name,
          hourPrice:
            sessionStorage.getItem('hour_price') == 0
              ? 0
              : sessionStorage.getItem('hour_price') * 100 ||
                record.hour_price * 100,
          clz:
            sessionStorage.getItem('clz') == 0
              ? sessionStorage.getItem('clz')
              : sessionStorage.getItem('clz') ||
                this.state.tableDetailInfo.table.clz,
          lampNumber:
            sessionStorage.getItem('table_number') || record.table_number,
          instantlyCheckout:
            sessionStorage.getItem('checkout') == null
              ? this.state.tableDetailInfo.table.instantlyCheckout
              : sessionStorage.getItem('checkout') == 1
              ? true
              : false,
          postpaid:
            sessionStorage.getItem('timeMode') == null
              ? this.state.tableDetailInfo.table.postpaid
              : sessionStorage.getItem('timeMode') == 1
              ? true
              : false,
          order:
            sessionStorage.getItem('order_num') ||
            this.state.tableDetailInfo.table.order,
        },
        group: {
          id: sessionStorage.getItem('type_id') || record.type,
          isNew: false,
        },
        minConsumption:
          sessionStorage.getItem('low_minute') == '' ||
          sessionStorage.getItem('low_minute') == 0
            ? 0
            : sessionStorage.getItem('low_minute') * 60 ||
              record.consumption * 60,
        settings: settings,
      }
      if (sessionStorage.getItem('low_minute')) {
        if (sessionStorage.getItem('low_minute').length > 6) {
          message.error('最低消费不能超过6位数')
          return
        }
      }
      if (params.table.clz != 1 && params.table.hourPrice == 0) {
        message.error('桌台价格设置不能低于零元')
        return
      }
      postTableDetail(params)
        .then((res) => {
          if (res.status != 1) {
            message.error(res.detail)
            return Promise.reject()
          }
        })
        .then(() => {
          message.success('操作成功')
          this.setState({
            visible: false,
          })
          this.props.fetchClubTable()
        })
        .catch((e) => {})
    }

    //设置钱包是否可用
    if (wallet_id !== 0) {
      const data = {
        classify_id: record.type,
        wallet_id: wallet_id,
      }
      this.props.fetchSetClassifyWallet(data)
    }

    this.setState({ visible: false }, () => {
      this.clearSession()
    })
    this.props.fetchClubTable()
  }

  clearSession = () => {
    sessionStorage.removeItem('name')
    sessionStorage.removeItem('type_id')
    sessionStorage.removeItem('clz')
    sessionStorage.removeItem('type')
    sessionStorage.removeItem('order_num')
    sessionStorage.removeItem('table_number')
    sessionStorage.removeItem('hour_price')
    sessionStorage.removeItem('checkout')
    sessionStorage.removeItem('timeMode')
    sessionStorage.removeItem('low_minute')
    sessionStorage.removeItem('packageOption')
    sessionStorage.removeItem('packageOperation')
    sessionStorage.removeItem('packageNeedFlashingReminder')
    sessionStorage.removeItem('packageNeedWechatReminder')
    sessionStorage.removeItem('couponOption')
    sessionStorage.removeItem('couponOperation')
    sessionStorage.removeItem('couponNeedFlashingReminder')
    sessionStorage.removeItem('couponNeedWechatReminder')
    sessionStorage.removeItem('grouponOperation')
    sessionStorage.removeItem('grouponNeedFlashingReminder')
    sessionStorage.removeItem('grouponNeedWechatReminder')
  }

  handleCancel = () => {
    this.setState({ visible: false }, () => this.clearSession())
  }

  handleCheckbox = (value) => {
    this.setState({ wallet_id: value })
  }

  /****************分时段模态框******************/
  onShowInterval = () => {
    const { selectedRowKeys } = this.state
    if (selectedRowKeys.length > 0) {
      this.setState({ modal: true })
    } else {
      message.info('请勾选需要设置的分时段价格的桌台')
    }
  }

  handleAffirm = () => {
    if (
      !this.state.weekDay ||
      this.state.weekDay.length == 0 ||
      !sessionStorage.getItem('time_price') ||
      !sessionStorage.getItem('start_time') ||
      !sessionStorage.getItem('end_time')
    ) {
      message.error('请填写完整信息')
      return
    }
    const table_id = this.state.tables.map((item) => {
      return item.table_id
    })
    const data = {
      wday: this.state.weekDay,
      sever_price: sessionStorage.getItem('time_price') || '0',
      start_time: sessionStorage.getItem('start_time') || '0000',
      end_time: sessionStorage.getItem('end_time') || '23:59',
      selectedId: table_id,
    }
    this.setState({ modal: false, selectedRowKeys: [] }, () => {
      this.props.fetchAddTimeInterval(data)
      sessionStorage.removeItem('time_price')
      sessionStorage.removeItem('start_time')
      sessionStorage.removeItem('end_time')
      this.onChangeDay([])
    })
  }

  handleCancelModal = () => {
    this.setState({ modal: false }, () => {
      sessionStorage.removeItem('time_price')
      sessionStorage.removeItem('start_time')
      sessionStorage.removeItem('end_time')
    })
  }

  //选择日期
  onChangeDay = (value) => {
    this.setState({ weekDay: value })
  }

  onSelectChange = (selectedRowKeys, tables) => {
    this.setState({ selectedRowKeys, tables })
  }

  /****************添加桌台*************************/
  handleAffirmAdd = (hintInfo) => {
    if (
      !(
        sessionStorage.getItem('name') &&
        sessionStorage.getItem('type_id') &&
        sessionStorage.getItem('clz') &&
        sessionStorage.getItem('order_num') &&
        sessionStorage.getItem('table_number') &&
        sessionStorage.getItem('hour_price')
      )
    ) {
      message.error('请完整填写信息')
      return
    }
    if (hintInfo && +sessionStorage.getItem('hour_price') <= 0) {
      message.info('桌台价格设置不能低于零元,请重新设置')
    } else {
      // let data = {
      //   club_id: sessionStorage.getItem('club_id'),
      //   name: sessionStorage.getItem('name'),
      //   table_number: sessionStorage.getItem('table_number'),
      //   hour_price: sessionStorage.getItem('hour_price'),
      //   low_minute: sessionStorage.getItem('low_minute') || 0,
      //   order_num: sessionStorage.getItem('order_num'),
      //   type_id: sessionStorage.getItem('type_id'),
      //   clz: sessionStorage.getItem('clz'),
      //   checkout: sessionStorage.getItem('checkout') || 0,
      // }
      // this.props.fetchClubAddTable(data, () => {
      //   this.setState({ modalAddTable: false })
      //   this.clearSession()
      // })

      const params = {
        table: {
          id: -1,
          name: sessionStorage.getItem('name'),
          hourPrice:
            sessionStorage.getItem('hour_price') == 0
              ? 0
              : sessionStorage.getItem('hour_price') * 100,
          clz:
            sessionStorage.getItem('clz') == 0
              ? sessionStorage.getItem('clz')
              : sessionStorage.getItem('clz') ||
                this.state.tableDetailInfo.table.clz,
          // postpaid: true,
          lampNumber: sessionStorage.getItem('table_number'),
          instantlyCheckout:
            sessionStorage.getItem('checkout') == 1 ? true : false,
          postpaid: sessionStorage.getItem('timeMode') == 1 ? true : false,
          order: sessionStorage.getItem('order_num'),
        },
        group: {
          id: sessionStorage.getItem('type_id'),
          isNew: false,
        },
        minConsumption:
          sessionStorage.getItem('low_minute') == ''
            ? 0
            : sessionStorage.getItem('low_minute') * 60,
      }
      if (params.table.clz != 1 && params.table.hourPrice == 0) {
        message.error('桌台价格设置不能低于零元')
        return
      }
      postTableDetail(params)
        .then((res) => {
          if (res.status != 1) {
            message.error(res.detail)
            return Promise.reject()
          }
        })
        .then(() => {
          message.success('操作成功')
          this.setState({
            visible: false,
          })
          this.props.fetchClubTable()
          this.handleCancelAdd()
        })
        .catch((e) => {})
    }
  }

  handleCancelAdd = () => {
    this.setState({ modalAddTable: false })
    this.clearSession()
  }

  //生成二维码
  clickCreate = (table_id, downloadFile, i) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/BuildUrl/table_id/${table_id}`
    let str
    return fetchData(endpoint).then((data) => {
      i && i++

      if (data.status == true) {
        message.success(data.detail)
        this.props.fetchClubTable()
        return true
      } else {
        message.error(data.detail ? data.detail : '抱歉,你没有权限')
        return false
      }
    })
  }

  // 下载单个球台二维码
  clickSingleTableDownload = (record) => {
    this.props.downloadSingleTableQrcode(record.name, record.table_id)
  }

  //下载二维码
  clickDownload = (downloadFile, download_url, i) => {
    return this.getBase64(download_url).then(
      (base64) => {
        this.downloadFile(base64, downloadFile)
        i && i++
        return true
      },
      (err) => {}
    )
  }

  //将远程图片转化为base64
  getBase64(img) {
    function getBase64Image(img, width, height) {
      //width、height调用时传入具体像素值，控制大小 ,不传则默认图像大小
      const canvas = document.createElement('canvas')
      canvas.width = width ? width : img.width
      canvas.height = height ? height : img.height

      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      return canvas.toDataURL()
    }
    const image = new Image()
    image.crossOrigin = ''
    image.src = img
    return new Promise((resolve, reject) => {
      image.onload = function () {
        resolve(getBase64Image(image)) //将base64传给done上传处理
      }
    })
  }

  downloadFile(url, filename) {
    const aLink = document.createElement('a')
    const evt = document.createEvent('MouseEvents')
    evt.initEvent('click', false, false)
    aLink.download = filename
    aLink.href = url
    aLink.dispatchEvent(evt)
  }

  /****************低消设置*************************/
  onShowLowCsp = () => {
    const { selectedRowKeys } = this.state
    if (selectedRowKeys.length > 0) {
      this.setState({ modalLowCsp: true })
    } else {
      message.info('请勾选需要设置的低消的桌台')
    }
  }

  handleAffirmLowCsp = (item) => {
    const table_id = this.state.tables.map((item) => {
      return item.table_id
    })
    const data = Object.assign(item, {
      selectedId: table_id,
      type: '1',
    })
    this.props.fetchLowConsumption(data, () => {
      this.setState({ modalLowCsp: false, selectedRowKeys: [] })
    })
  }

  handleCancelLowCsp = () => {
    this.setState({ modalLowCsp: false })
  }

  //一键生成所有二维码
  createAllQrCode = async () => {
    const list = this.props.list
    let i = 0
    for (let record of list) {
      try {
        record.download_url === 0 &&
          (await this.clickCreate(record.table_id, record.name))
      } catch (e) {}
      i++
      if (i === list.length) {
        message.success('操作完成')
        this.setState({ createPercent: -1 })
      } else {
        this.setState({ createPercent: (i / list.length).toFixed(2) * 100 })
      }
    }
  }

  //一键下载所有二维码
  downAllQrCode = async () => {
    this.props.downloadTableQrCodes()
    return
    const list = this.props.list
    let i = 0
    for (let record of list) {
      try {
        record.download_url !== 0 &&
          (await this.clickDownload(record.name, record.download_url))
      } catch (e) {}
      i++
      if (i === list.length) {
        message.success('操作完成')
        this.setState({ createPercent: -1 })
      } else {
        this.setState({ createPercent: (i / list.length).toFixed(2) * 100 })
      }
    }
  }

  handlePackageManager() {
    this.setState((preState) => ({
      isShowPackageManager: !preState.isShowPackageManager,
    }))
  }

  handleShowEditModal() {
    this.setState((preState) => ({
      isShowBatchEditModal: !preState.isShowBatchEditModal,
    }))
  }

  onshowBatchEditModal() {
    const { selectedRowKeys } = this.state
    if (selectedRowKeys.length > 0) {
      this.handleShowEditModal()
    } else {
      message.info('请勾选需要设置的低消的桌台')
    }
  }
  handleCancelBatchEdit = () => {
    this.setState({
      isShowBatchEditModal: false,
    })
  }

  handleAffirmBatchEdit = () => {
    this.setState({
      isShowBatchEditModal: false,
    })
  }

  handleCancelPackageManager = () => {
    this.setState({ isShowPackageManager: false })
  }

  handleAffirmPackageManager = () => {
    this.setState({ isShowPackageManager: false })
  }

  createNumMethod = () => {
    const { list } = this.props
    if (list) {
      let notCreateNum = 0
      let haveCreateNum = 0
      list.forEach((v) => {
        v.download_url === 0 && notCreateNum++
      })
      haveCreateNum = list.length - notCreateNum
      return {
        notCreateNum,
        haveCreateNum,
      }
    }
    return {
      notCreateNum: 0,
      haveCreateNum: 0,
    }
  }

  hideBookSettingsModal = () => {
    this.setState({
      visible: false,
    })
  }

  // 新增桌台
  onAddTableOk = async (tableData) => {
    // tableData.table.hourPrice = tableData.table.hourPrice * 100
    // tableData.minConsumption = tableData.minConsumption * 60
    const params = JSON.parse(JSON.stringify(tableData))
    params.table.hourPrice = params.table.hourPrice * 100
    params.minConsumption = params.minConsumption * 60
    const { data, status, detail } = await postTableDetail(params)
    if (status != 1) {
      message.error(detail)
      return
    }
    this.props.fetchClubTable().then((res) => {
      this.setState({ loading: false })
    })
    message.success('新增成功')
    this.setState({
      modalAddTable: false,
    })
  }

  // 批量重置低消
  setTablesLowPrice = async () => {
    const { selectedRowKeys } = this.state
    if (selectedRowKeys.length == 0) {
      message.info('请勾选需要设置的低消的桌台')
      return
    }
    const clubId = sessionStorage.getItem('club_id')
    const { data, status, detail } = await postTablesLowPrice({
      clubId,
      selectedId: selectedRowKeys,
    })
    if (status != 1) {
      message.error(detail)
      return
    }
    message.success('重置成功')
    this.setState({
      selectedRowKeys: [],
    })
  }

  // 批量重置分时段设置
  setTablesTimePrice = async () => {
    const { selectedRowKeys } = this.state
    if (selectedRowKeys.length == 0) {
      message.info('请勾选需要设置的低消的桌台')
      return
    }
    const clubId = sessionStorage.getItem('club_id')
    const { data, status, detail } = await postTablesTimePrice({
      clubId,
      selectedId: selectedRowKeys,
    })
    if (status != 1) {
      message.error(detail)
      return
    }
    message.success('重置成功')
    this.setState({
      selectedRowKeys: [],
    })
  }



  render() {
    const { list, timePrice, tableType, tableInfo, walletType, totalType } =
      this.props
    const {
      createPercent,
      downloadPercent,
      isShowPackageManager,
      isShowBatchEditModal,
      tableTypes,
      showBookSettingsModal,
      isLoading,
    } = this.state
    const { notCreateNum, haveCreateNum } = this.createNumMethod()
    const type_name = tableTypes.map((item) => {
      return { text: item.name, value: item.name }
    })
    const total = totalType.map((item) => {
      return { text: item.type_name, value: item.type_name }
    })
    const data = list.map((item) => {
      if (item.total_c === '0') {
        item.total = '台球'
      } else if (item.total_c === '1') {
        item.total = '休闲区'
      } else if (item.total_c === '2') {
        item.total = '棋牌'
      } else if (item.total_c === '3') {
        item.total = '飞镖机'
      }
      if (item.temporary_number.length !== 0) {
        item.temporary_status = '使用中...'
      } else {
        item.temporary_status = '空闲'
      }
      return item
    })
    const columns = [
      {
        title: '编号',
        dataIndex: 'order_num',
        key: 'order_num',
        width: 200,
      },
      {
        title: '桌台名称',
        dataIndex: 'name',
        key: 'name',
        width: 220,
      },
      {
        title: '分组',
        dataIndex: 'type_name',
        key: 'type_name',
        width: 220,
        filters: type_name,
        filterMultiple: false,
        onFilter: (value, record) => record.type_name.indexOf(value) === 0,
      },
      {
        title: '类型',
        dataIndex: 'total',
        key: 'total',
        width: 200,
        filters: total,
        filterMultiple: false,
        onFilter: (value, record) => record.total.indexOf(value) === 0,
      },
      {
        title: '价格[元/小时]',
        dataIndex: 'hour_price',
        key: 'hour_price',
        width: 200,
        sorter: (a, b) => a.hour_price - b.hour_price,
      },
      {
        title: '状态',
        dataIndex: 'temporary_status',
        key: 'temporary_status',
        width: 200,
      },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <div className="edit-detail">
              <Button
                type="primary"
                style={{ marginRight: '20px' }}
                onClick={() => this.onShow(record)}
              >
                详情
              </Button>
              {/* {record.download_url == 0 ? (
                <Button
                  type="primary"
                  onClick={() => this.clickCreate(record.table_id, record.name)}
                >
                  生成二维码
                </Button>
              ) : ( */}
              <Button
                type="primary"
                onClick={
                  () => this.clickSingleTableDownload(record)
                  // this.clickDownload(record.name, record.download_url)
                }
              >
                下载二维码
              </Button>
              {/* )} */}
              <Popconfirm
                title={`你确认要删除${record.name}桌台吗?`}
                okText="确认"
                cancelText="取消"
                onConfirm={() => this.props.fetchDeleteTable(record.table_id)}
              >
                <Button type="primary" danger style={{ marginLeft: '20px' }}>
                  删除
                </Button>
              </Popconfirm>
            </div>
          )
        },
      },
    ]

    const { selectedRowKeys } = this.state
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    }
    const hasSelected = selectedRowKeys.length > 0
    return (
      <div className="table">
        <div className="column_view">
          <div className="column_left">
            <Button
              type="primary"
              onClick={() => {
                this.setState({ modalAddTable: true })
              }}
            >
              添加桌台
            </Button>
            <Button
              type="primary"
              style={{
                marginLeft: '20px',
                display: haveCreateNum ? 'inline-block' : 'none',
              }}
              onClick={this.downAllQrCode}
            >
              一键下载二维码({haveCreateNum})
              {downloadPercent === -1 ? '' : Math.round(downloadPercent) + '%'}
            </Button>
          </div>
          <div className="column_right">
            {this.state.isShowReserve && (
              <Button
                type="primary"
                onClick={() => {
                  if (this.state.tables.length == 0) {
                    message.error('请选择要设置的球台')
                    return
                  }
                  this.setState({ showBookSettingsModal: true })
                }}
              >
                批量预订设置
              </Button>
            )}
          </div>
        </div>
        <Table
          rowKey="table_id"
          bordered
          columns={columns}
          dataSource={data}
          rowSelection={rowSelection}
          pagination={false}
          style={{ marginTop: '15px' }}
          scroll={{ y: +window.innerHeight - 350 }}
          loading={isLoading}
        />
        <div className="table-btn">
          <div className="table-edit-btn">
            <span style={{ marginLeft: 8, marginRight: 8 }}>
              {hasSelected ? `已勾选 ${selectedRowKeys.length} 条数据` : ''}
            </span>
            <Button type="primary" onClick={() => this.onShowInterval()}>
              批量设置分时段
            </Button>
            <Popconfirm
              title={`你确认要重置吗?重置后所选分时段设置将清零`}
              okText="确认"
              cancelText="取消"
              onConfirm={() => this.setTablesTimePrice()}
            >
              <Button type="primary" danger style={{ marginLeft: '1rem' }}>
                批量重置分时段设置
              </Button>
            </Popconfirm>
          </div>
          <div className="table-edit-btn">
            <Button type="primary" onClick={() => this.onshowBatchEditModal()}>
              批量设置套餐
            </Button>
            <Button
              type="primary"
              danger
              ghost
              style={{ marginLeft: '1rem' }}
              onClick={() => this.handlePackageManager()}
            >
              套餐管理
            </Button>
          </div>
          <div className="table-edit-btn">
            <Button type="primary" onClick={() => this.onShowLowCsp()}>
              批量设置低消
            </Button>
            <Popconfirm
              title={`你确认要重置吗?重置后所选球台将无最低消费`}
              okText="确认"
              cancelText="取消"
              onConfirm={() => this.setTablesLowPrice()}
            >
              <Button type="primary" danger style={{ marginLeft: '1rem' }}>
                批量重置低消设置
              </Button>
            </Popconfirm>
          </div>
        </div>

        {
          // 点击列表详情 弹框
          this.state.visible && (
            <ModalDetail
              {...this.state}
              {...this.props}
              handleOk={this.handleOk}
              handleCancel={this.handleCancel}
              handleCheckbox={this.handleCheckbox}
              hideBookSettingsModal={this.hideBookSettingsModal}
            />
          )
        }
        {
          // 批量设置分时段 弹框
          this.state.modal && (
            <ModalInterval
              {...this.state}
              handleOk={this.handleAffirm}
              handleCancel={this.handleCancelModal}
              onChangeDay={this.onChangeDay}
            />
          )
        }
        {
          // 批量设置低消 弹框
          this.state.modalLowCsp && (
            <LowCsp
              {...this.state}
              handleOk={this.handleAffirmLowCsp}
              handleCancel={this.handleCancelLowCsp}
            />
          )
        }
        {
          // 套餐管理 弹框
          isShowPackageManager && (
            <PackageManager
              handleOk={this.handleAffirmPackageManager}
              handleCancel={this.handleCancelPackageManager}
              {...this.state}
              {...this.props}
            />
          )
        }
        {
          // 批量设置套餐 弹框
          isShowBatchEditModal && (
            <BatchEditPackage
              handleOk={this.handleAffirmBatchEdit}
              handleCancel={this.handleCancelBatchEdit}
              {...this.state}
              {...this.props}
            />
          )
        }
        {/* 添加球台 */}
        {this.state.modalAddTable && (
          <TableInfoModal
            close={() => this.setState({ modalAddTable: false })}
          />
        )}
        {/* 批量预订设置 */}
        {showBookSettingsModal && (
          <BooksettingsModal
            tables={this.state.tables}
            close={() =>
              this.setState({
                showBookSettingsModal: false,
              })
            }
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/tableList.js